import { Component } from '@angular/core';

@Component({
    selector: 'app-no-access',
    styleUrls: ['./no-access.component.css'],
    standalone: true,
    template: `<div class="page">
        <div class="no-access-container">
            <div class="flex-row">
                <h1 class="center">Access Denied</h1>
            </div>
            <div class="flex-row">
                <p class="center">You don't have access to this page. Contact a SIDeX admin for access.</p>
            </div>
        </div>
    </div> `
})
export class NoAccessComponent {}
